import { render, staticRenderFns } from "./DataSourceFuturesData.vue?vue&type=template&id=01dcbfe8&scoped=true&"
import script from "./DataSourceFuturesData.vue?vue&type=script&lang=js&"
export * from "./DataSourceFuturesData.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceFuturesData.vue?vue&type=style&index=0&id=01dcbfe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dcbfe8",
  null
  
)

export default component.exports